export default {
  shared: {
    appVersion: "App-Version",
    brand: "Marke",
  },
  assignBeforePairing:
    "Weisen Sie dieses Gerät einer Struktur zu, bevor Sie ein Lesegerät verknüpfen",
  deviceRevoked: "Gerät widerrufen",
  deviceReactivated: "Gerät reaktiviert",
  deviceShelved: "Gerät geparkt",
  deviceUnshelved: "Gerät wieder im Einsatz",
  credentialsRegenerated: "Zugangsdaten neu generiert",
  kioskAssigned: "Gerät erfolgreich zugewiesen",
  readerUpdated: "Lesegerät aktualisiert",
  deviceRenamed: "Anzeigename aktualisiert",
  deviceGoogleAccountUpdated: "Google-Konto aktualisiert",
  deviceNotesUpdated: "Notizen aktualisiert",
  page: {
    kpiTotal: "Aktive Geräte",
    kpiTotalHint: "Ohne widerrufene",
    kpiOnline: "Online",
    kpiOnlineHint: "Vollständige Telemetrie in den letzten 20 h",
    kpiIncomplete: "Einrichtung unvollständig",
    kpiIncompleteHint: "Kopplung, Lesegerät oder Unterkunft fehlt",
    kpiShelved: "Geparkt",
    kpiShelvedHint: "Nicht im Einsatz",
    title: "Geräteverwaltung",
    subtitle: "Geräte für Strukturen verwalten",
    newDevice: "Neues Gerät",
    tabDevices: "Geräte",
    tabPresets: "Gerätevorlagen",
    searchPlaceholder: "Suche nach Name, Code, Struktur oder anderem…",
    filterActiveLabel: "Aktiv",
    filterActiveAll: "Alle",
    filterActiveActive: "Aktiv",
    filterActiveInactive: "Inaktiv",
    filterSetupLabel: "Einrichtung",
    filterSetupAll: "Alle",
    filterSetupComplete: "Vollständig",
    filterSetupIncomplete: "Unvollständig",
    filterSetupRevoked: "Widerrufen",
    filterShelvedLabel: "Parkstatus",
    filterShelvedAll: "Alle",
    filterShelvedInService: "Im Einsatz",
    filterShelvedOnly: "Geparkt",
    filterTelemetryLabel: "Telemetriestatus",
    filterTelemetryAll: "Alle",
    filterTelemetryGray: "Nicht gebunden",
    filterTelemetryGreen: "Vollständig",
    filterTelemetryYellow: "Unvollständig",
    filterTelemetryRed: "Kein Bericht (> 20 Std.)",
    filterAppVersionAny: "Beliebig",
    filterAppVersionCount: "{{count}} ausgewählt",
    filterIncompleteMissingLabel: "Details unvollständige Einrichtung",
    filterIncompleteMissingAny: "Beliebig",
    filterIncompleteMissingCount: "{{count}} ausgewählt",
    filterMissingBinding: "Softwareschlüssel fehlt",
    filterMissingReader: "Lesegerät fehlt",
    filterMissingStructure: "Struktur fehlt",
    telemetryTooltipGray: "Nicht angemeldet oder nicht gebunden",
    telemetryTooltipGreen: "Vollständige Telemetrie",
    telemetryTooltipYellow: "Unvollständige Telemetrie",
    telemetryTooltipRed: "Keine Telemetrie (> 20 Std.)",
    setupBadgeIncomplete: "Unvollständig",
    setupBadgeRevoked: "Widerrufen",
    setupBadgeIncompleteTooltipTitle: "Noch erforderlich:",
    setupBadgeIncompleteTooltipDesc:
      "Dieses Gerät kann keine Zahlungen annehmen, bis die Einrichtung abgeschlossen ist.",
    setupBadgeRevokedTooltip: "Dieses Gerät wurde widerrufen",
    setupMissingBinding: "Softwareschlüssel-Bindung",
    setupMissingBindingDesc:
      "Das Tablet muss sich mindestens einmal mit seinem Softwareschlüssel anmelden.",
    setupMissingPairing: "Verknüpfung mit Zahlungsleser",
    setupMissingPairingDesc:
      "Ein Zahlungsleser muss mit diesem Tablet verknüpft sein, um Kartenzahlungen zu verarbeiten.",
    setupMissingAssignment: "Strukturzuweisung",
    setupMissingAssignmentDesc:
      "Das Gerät muss einer Host-Struktur zugewiesen sein.",
    colDevice: "Anzeigename",
    colSerial: "S/N",
    colGoogleAccount: "Google-Konto",
    colFreekioskUnlock: "FK-Entsperrung",
    colReader: "Lesegerät",
    colHouse: "Struktur",
    colLastTelemetry: "Letzte Telemetrie",
    colLastInteraction: "Letzte Interaktion",
    colInUse: "Im Einsatz",
    colActions: "Aktionen",
    selectRow: "{{name}} auswählen",
    selectAllFiltered: "Alle {{count}} gefilterten auswählen",
    exportCsv: "CSV exportieren",
    emptySearch: "Keine Geräte entsprechen Ihrer Suche.",
    emptyDefault:
      "Keine Geräte gefunden. Erstellen Sie Ihr erstes Gerät, um zu beginnen.",
    readerPair: "Verknüpfen",
    readerUnpairTitle: "Lesegerät trennen",
    readerUnpairConfirm:
      "Lesegerät von diesem Tablet trennen? Die SumUp-Kopplung bleibt erhalten; Zahlungen bleiben deaktiviert, bis Sie erneut verknüpfen.",
    readerUnpaired: "Lesegerät getrennt",
    houseOpenTitle: "Struktur öffnen",
    houseRemoveTitle: "Struktur vom Gerät entfernen",
    houseRemoveConfirm:
      "„{{name}}“ von diesem Gerät entfernen? Es wird nicht mehr zugewiesen sein.",
    houseRemoved: "Struktur entfernt",
    assign: "Zuweisen",
    moreActionsTitle: "Weitere Aktionen",
    regenerateConfirm:
      "Passwort für „{{name}}“ neu generieren? Bestehende Tablet-Sitzungen werden ungültig und das aktuelle Passwort funktioniert nicht mehr.",
    credentialModalTitle: "Zugangsdaten neu generiert",
    credentialModalDesc:
      "Das Passwort wurde neu generiert. Speichern Sie diese Zugangsdaten jetzt: Das Passwort wird nur einmal angezeigt.",
    statusPartial: "Teilweise konfiguriert",
    assignModalTitle: "Gerät zuweisen",
    assignModalIntro: "Weisen Sie {{name}} einem Host und einer Struktur zu.",
    selectHostStep: "1) Host auswählen",
    selectHouseStep: "2) Struktur auswählen",
    searchHostsPlaceholder: "Hosts suchen…",
    searchHousesPlaceholder: "Strukturen suchen…",
    searchHousesDisabledPlaceholder: "Zuerst einen Host auswählen…",
    noHostsFound: "Keine Hosts gefunden.",
    pickHostForHouses:
      "Wählen Sie einen Host, um dessen Strukturen anzuzeigen.",
    noHousesFound: "Keine Strukturen gefunden.",
    noAddressSet: "Keine Adresse hinterlegt",
    assignedDevicesLabel: "Zugewiesene Geräte:",
    assignSubmit: "Zuweisen",
    otherInfoTitle: "Weitere Geräteinformationen",
    fieldDisplayName: "Anzeigename",
    fieldKioskCode: "Gerätecode",
    fieldSerialNumber: "Seriennummer",
    fieldSoftwareId: "Software-ID",
    fieldGoogleAccount: "Google-Konto",
    fieldReaderId: "Lesegerät-ID",
    fieldDisplayInches: "Display-Zoll",
    fieldResolution: "Auflösung",
    fieldAndroidVersion: "Android-Version",
    valueAppVersionUnknown: "Unbekannt",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    editNotesTitle: "Notizen",
    notesPlaceholder: "Notiz hinzufügen…",
    fieldLastTelemetryReport: "Letzte empfangene Telemetrie",
    sectionTelemetryData: "Telemetriedaten",
    sectionTelemetryDeviceStatus: "Gerätestatus (FreeKiosk)",
    sectionTelemetryGpsLocation: "Standort (Geräte-GPS)",
    valueTelemetryNever: "Nie",
    valueTelemetryEmpty: "Noch keine Daten",
    fieldHouse: "Struktur",
    valueUnbound: "Nicht gebunden",
    valueNotPaired: "Nicht verknüpft",
    valueUnassigned: "Nicht zugewiesen",
    menuRegenerateCredentials: "Zugangsdaten neu generieren",
    menuRevokeDevice: "Anmeldedaten widerrufen",
    menuReactivateDevice: "Anmeldedaten reaktivieren",
    menuNotes: "Notizen",
    menuOtherInfo: "Weitere Infos",
    renameDeviceTitle: "Anzeigename bearbeiten",
    displayNamePlaceholder: "Anzeigename",
    displayNameEmpty: "Anzeigename darf nicht leer sein",
    editGoogleAccountTitle: "Google-Konto bearbeiten",
    telemetryBattery: "Akku",
    telemetryWifi: "WLAN-Signal",
    telemetryAudio: "Lautstärke",
    telemetryStorage: "Speicher belegt",
    telemetryMemory: "RAM belegt",
    telemetryUnavailable: "-",
    telemetryDataAge: "Daten von {{age}}",
  },
  createModal: {
    titleCreate: "Neues Gerät erstellen",
    titleCreated: "Gerät erstellt!",
    hardwareIdLabel: "Seriennummer",
    hardwareIdPlaceholder: "z. B. R52N80ABCDE",
    hardwareIdRequired: "Bitte geben Sie die Seriennummer des Tablets ein",
    googleAccountLabel: "Google-Konto",
    googleAccountPlaceholder: "z. B. tablet@unternehmen.com",
    googleAccountRequired:
      "Bitte geben Sie die E-Mail-Adresse des Google-Kontos ein",
    displayNameLabel: "Anzeigename (optional)",
    displayNamePlaceholder: "z. B. Lobby-Tablet",
    presetSelectorTitle: "Gerätevorlage auswählen",
    presetsEmpty:
      "Keine Vorlagen gefunden. Sie können eine auf der Seite Gerätevorlagen erstellen oder unten den manuellen Modus verwenden.",
    presetCardSpecs: 'Android {{version}} • {{resolution}} • {{inches}}"',
    presetRequired:
      "Bitte wählen Sie eine Gerätevorlage oder wechseln Sie in den manuellen Modus",
    manualToggle: "Hardwaredetails manuell eingeben",
    brandPlaceholder: "z. B. Samsung",
    androidVersionLabel: "Android-Version",
    androidVersionPlaceholder: "z. B. 14",
    resolutionLabel: "Display-Auflösung",
    resolutionPlaceholder: "z. B. 1920x1200",
    inchesLabel: "Display-Zoll",
    inchesPlaceholder: "z. B. 10.1",
    inchesInvalid: "Display-Zoll muss eine gültige Zahl sein",
    submit: "Gerät erstellen",
    successTitle: "Gerät erfolgreich erstellt!",
    successDescription:
      "Verwenden Sie diese Zugangsdaten, um sich vom Tablet aus anzumelden. Sie werden nicht erneut angezeigt.",
    deviceNameLabel: "Anzeigename",
    modelLabel: "Modell",
    modelPlaceholder: "z. B. Tab A9",
    kioskCodeLabel: "Gerätecode",
    passwordLabel: "Passwort",
    qrHelp:
      "Scannen Sie diesen QR-Code auf dem Tablet-Anmeldebildschirm, um die Zugangsdaten automatisch auszufüllen.",
    importantLabel: "Wichtig:",
    importantDescription:
      "Speichern Sie diese Zugangsdaten jetzt. Jeder, der diesen QR-Code scannt, kann sich anmelden, bis Sie das Passwort neu generieren.",
  },
  presets: {
    validationRequired: "Alle Felder sind erforderlich",
    validationDisplayInches:
      "Display-Zoll muss eine gültige Zahl größer als null sein",
    created: "Vorlage erstellt",
    updated: "Vorlage aktualisiert",
    deleted: "Vorlage gelöscht",
    deleteConfirm: "Vorlage „{{name}}“ löschen?",
    brandPlaceholder: "Marke (z. B. TCL)",
    modelPlaceholder: "Modell (z. B. TAB 10L)",
    androidVersionPlaceholder: "Android-Version (z. B. 15)",
    resolutionPlaceholder: "Auflösung (z. B. 800x1280)",
    inchesPlaceholder: "Zoll (z. B. 10.1)",
    save: "Vorlage speichern",
    add: "Vorlage hinzufügen",
    colModel: "Modell",
    colAndroid: "Android",
    colResolution: "Auflösung",
    colInches: "Zoll",
    inchesValue: "{{inches}}″",
    colActions: "Aktionen",
    empty: "Noch keine Vorlagen.",
    editTitle: "Vorlage bearbeiten",
    deleteTitle: "Vorlage löschen",
  },
} as const;
